/**
 * Где запущен интерфейс: в браузере (сервер — тот же адрес) или в десктопном клиенте
 * (ADR-0009, T-185): интерфейс внутри программы, сервер — адрес, заданный при первом запуске.
 */

const SERVER_KEY = 'sww.server.v1';

export const isDesktop = typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window;

/** Мост приложения для Android (T-173, `android/`): то, чего нет в системном WebView. */
export interface AndroidBridge {
  appVersion(): string;
  shareFile(base64: string, name: string, mime: string): void;
  saveFile(base64: string, name: string, mime: string): void;
  changeServer(): void;
  openUrl(url: string): void;
}

/** Приложение для Android (WebView) — или null в браузере и в программе для Windows. */
export function androidApp(): AndroidBridge | null {
  const w = window as { SwwAndroid?: AndroidBridge };
  return w.SwwAndroid ?? null;
}

/** Адрес сервера в десктопном клиенте: «http://192.168.1.10:8080», без «/» в конце. */
export function serverUrl(): string | null {
  if (!isDesktop) return null;
  try {
    return window.localStorage.getItem(SERVER_KEY);
  } catch {
    return null;
  }
}

export function normalizeServerUrl(raw: string): string | null {
  const text = raw.trim();
  if (!text) return null;
  // Чужая схема (ftp://…) — не сервер склада.
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(text) && !/^https?:\/\//i.test(text)) return null;
  try {
    const url = new URL(/^https?:\/\//i.test(text) ? text : `http://${text}`);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
    return url.origin;
  } catch {
    return null;
  }
}

export function saveServerUrl(url: string): void {
  window.localStorage.setItem(SERVER_KEY, url);
}

/**
 * Адрес системы для людей и камеры телефона — ссылки в QR этикеток. В браузере это сам сайт,
 * в десктопе — сервер: адрес окна программы снаружи не откроется.
 */
export function publicBase(): string {
  return serverUrl() ?? window.location.origin;
}
